import React, { useEffect, useState } from "react";
import "../styles/ReviewManagementPage.css";
import MyPageSidebar from "./MyPageSidebar";
import MyPageEmpty from "./MyPageEmpty";
import ReviewManagementSection from "./ReviewManagementSection";

const ReviewManagementPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [reviews, setReviews] = useState([]);
    const [myReviews, setMyReviews] = useState([]);
    const [myReviewDataCount, setMyReviewDataCount] = useState(0);
    const [reviewableItemsCount, setReviewableItemsCount] = useState(0);

    useEffect(() => {
        // 🔥 예제 데이터 (실제 프로젝트에서는 API 호출)
        const getReviews = async () => {
            try {
                const response = await fetch("/api/review-list");
                if (!response.ok) {
                    throw new Error("리뷰관리 데이터 가져오기 실패");
                }
                const data = await response.json();
                setReviews(data.reviewableItems || []);
                setMyReviews(data.myReviewData || []);
                setMyReviewDataCount(data.myReviewDataCount || 0);
                setReviewableItemsCount(data.reviewableItemsCount || 0);

            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        console.log(reviews.length);
        console.log(myReviews.length);
        getReviews();
    }, []);

    if (isLoading) return <p>로딩 중...</p>;

    return (
        <div className="mypage-layout">
            <MyPageSidebar />
            <div className="mypage-content-list-container">
                {/*<h2 className="mypage-title">리뷰 관리</h2>*/}
                <ReviewManagementSection reviewableItemsCount={reviewableItemsCount} reviews={reviews} myReviewCount={myReviewDataCount} myReviews={myReviews} />
            </div>
        </div>
    );
};

export default ReviewManagementPage;
